import { Autocomplete } from "@msys/ui";
import { sortBy } from "lodash-es";
import React from "react";
import { ItemSelect_ItemFragment } from "./ItemSelect.generated";

export interface Props {
  itemId: string | null;
  onChange: (item: ItemSelect_ItemFragment | null) => void | Promise<void>;
  items: ItemSelect_ItemFragment[];

  inputLabel: string;
  placeholder?: string;
  required?: boolean;
  error?: string;
  disabled?: boolean;
  size?: React.ComponentProps<typeof Autocomplete>["size"];
}

export const ItemSelect = ({
  itemId,
  onChange,
  items,
  inputLabel,
  placeholder,
  required,
  error,
  disabled,
  size,
}: Props) => {
  return (
    <Autocomplete
      placeholder={placeholder}
      options={sortBy(items, i => i.pathSortable)}
      getOptionLabel={formatItem}
      inputLabel={inputLabel}
      required={required}
      value={items.find(i => i.id === itemId) ?? null}
      onChange={onChange}
      error={error}
      disabled={disabled}
      size={size}
    />
  );
};

export function formatItem(item: ItemSelect_ItemFragment) {
  return `${item.pathForPdf} ${item.title}`.trim();
}
